{
  "name": "zippel-staff-frontend",
  "version": "1.0.6",
  "description": "Zippel Staff Portal Frontend",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "build:staging": "vite build --mode staging",
    "build:production": "vite build --mode production",
    "preview": "vite preview",
    "test": "vitest run --passWithNoTests"
  },
  "dependencies": {
    "@zippel/frontend-shared": "*",
    "axios": "^1.18.1",
    "lucide-react": "^0.563.0",
    "prop-types": "^15.8.1",
    "react": "19.1.0",
    "react-dom": "19.1.0",
    "react-router-dom": "^6.30.3"
  },
  "devDependencies": {
    "@types/react": "^19.1.0",
    "@types/react-dom": "^19.1.0",
    "@vitejs/plugin-react": "^6.0.3",
    "typescript": "^5.7.2",
    "vite": "^8.1.5",
    "vitest": "^4.1.10"
  }
}
